module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SS-3f11116a8257dcdc42ffe3f29a6e8f58.png";